
import * as PIXI from 'pixi.js';
import {Button} from './component/Button';
import {TimelinePlus} from './component/TimelinePlus';

import {Const} from './Const';
import {TweenMax,TimelineMax,Sine, PixiPlugin} from "gsap";
import "gsap/PixiPlugin";
import { Logo } from './component/Logo';
import { Names } from './component/Names';
import * as WebFont from 'webfontloader'


export class Main {
	static instance:Main;
	x: number;
	y: number;

	stage:PIXI.Container;
	topContainer:PIXI.Container;
	topMask:PIXI.Graphics;
	backGround:PIXI.Graphics;
	backgradation:PIXI.Sprite;
	blackgradation:PIXI.Sprite;
	face01:PIXI.Sprite;
	face02:PIXI.Sprite;
	bird:PIXI.Sprite;
	
	tweenbox:PIXI.Graphics;

	logo:Logo;
	names:Names;

	buttons:Button[] = [];
	renderer;

	traceText:PIXI.Text;
	device:string;

	baseH:number;
	baseW:number;

	paramArray:string[] = [];
	active:Boolean;

	animeType:string = '9';

	constructor() {
		Main.instance = this;
		this.update = this.update.bind(this);
		this.device = this.getDevice();
		
		var urlParam = location.search.substring(1);
 		// URLにパラメータが存在する場合
		if(urlParam) {
			// 「&」が含まれている場合は「&」で分割
			var param = urlParam.split('&');
			// パラメータを格納する用の配列を用意
			var paramArray = [];
					// 用意した配列にパラメータを格納
			for (let i = 0; i < param.length; i++) {
				var paramItem = param[i].split('=');
				if(paramItem[0] == 'active') {
					this.active = true;
				} 
				if(paramItem[0] == 'type') {
					this.animeType = paramItem[1];
				}
				paramArray[paramItem[0]] = paramItem[1];
			}
		}




		this.init();

	}

	getDevice():string{
		var ua = navigator.userAgent;
		console.log(ua);
    if(ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0){
        return 'sp';
    } else if(ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0){
        return 'tab';
    } else {
        return 'pc';
    }
	};


	init() {
		var width = document.documentElement.clientWidth;
		var height = window.innerHeight;
		//var height = document.documentElement.clientHeight;
		//広い方をWに格納
		if(width>height) {
			this.baseW = width;
			this.baseH = height;
		} else {
			this.baseW = height;
			this.baseH = width;
		}
		const ratio = (this.device==='pc')?1:window.devicePixelRatio || 1;

		var params = {
			backgroundColor: 0x000,   // 背景色の指定（灰色）
			antialias:true,
			resolution: ratio
		};

		PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.LINEAR;
		PIXI.settings.MIPMAP_TEXTURES = true;
		this.renderer = PIXI.autoDetectRenderer(width, height,params);
		this.renderer.antialias = true;
		this.renderer.view.style.position = "absolute";
		this.renderer.view.style.display = "block";
		this.renderer.view.style['touch-action'] = 'auto';
		//this.renderer.plugins.interaction.cursorStyles.default = 'pointer';
		//this.renderer.plugins.interaction.cursorStyles.hover = 'pointer';
		this.renderer.plugins.interaction.autoPreventDefault = false;

		//renderer.autoResize = true;
		this.renderer.resize(document.documentElement.clientWidth, document.documentElement.clientHeight);

		// レンダラーのviewをDOMに追加する
		var canvasScale = 1 / ratio;
		document.getElementById("topCanvas").appendChild(this.renderer.view);
		
		document.getElementById("topCanvas").style.transform='scale3d(' + canvasScale + ',' + canvasScale + ',' + canvasScale + ')';
		document.getElementById("topCanvas").style.transformOrigin = '0 0';
		this.stage = new PIXI.Container();   // ステージを生成
	
		this.topContainer = new PIXI.Container();
		this.stage.addChild(this.topContainer);
	
		//画像の読み込み
	
		PIXI.loader
		.add("img/top/top_bg_gradation.jpg")
		//.add("img/top/top_main.jpg")
		.add("img/top/faceA.png")
		.add("img/top/faceB.png")
		.add("img/top/bird_02.png")
		.add("img/top/white.png")
		.add("img/top/whitegradation.png")
		.add("img/top/blackgradation.png")
		.add('sprite', 'img/top/logo/sprites.json')
		.load(this.setup.bind(this));
		
	}
	
	setup() {
		document.getElementById("topCanvas").style.visibility = 'visible'
		document.getElementById("loading").style.visibility = 'hidden';

		this.backGround = new PIXI.Graphics(); 
		this.backGround.beginFill(0x794fb1);
		this.backGround.drawRect(0,0,1920,1200);
		this.backGround.endFill();

		this.topMask = new PIXI.Graphics();
		this.topMask.beginFill(0xFF0000);
		this.topMask.drawRect(0,0,100,100);
		this.topMask.endFill();

		

		this.backgradation = new PIXI.Sprite(PIXI.loader.resources["img/top/whitegradation.png"].texture);
		//backGround = new PIXI.Sprite(PIXI.loader.resources["img/top/top_main.jpg"].texture);
		this.backgradation.tint = 0x368db1;
		this.blackgradation = new PIXI.Sprite(PIXI.loader.resources["img/top/blackgradation.png"].texture);
		this.blackgradation.alpha = 0.5;

		this.face01 = new PIXI.Sprite(PIXI.loader.resources["img/top/faceA.png"].texture);
		this.face02 = new PIXI.Sprite(PIXI.loader.resources["img/top/faceB.png"].texture);
		this.bird = new PIXI.Sprite(PIXI.loader.resources["img/top/bird_02.png"].texture);
	
		this.topContainer.addChild(this.backGround);
		this.topContainer.addChild(this.backgradation);
		this.topContainer.addChild(this.blackgradation);
		//this.topContainer.addChild(this.face01);
		//this.topContainer.addChild(this.face02);
		this.stage.addChild(this.face01);
		this.stage.addChild(this.face02);
		this.face02.visible = true;
		this.face02.alpha = 0;
		this.face01.blendMode = PIXI.BLEND_MODES.MULTIPLY;
		this.face02.blendMode = PIXI.BLEND_MODES.MULTIPLY;
		this.bird.blendMode = PIXI.BLEND_MODES.MULTIPLY;
	
		this.topContainer.addChild(this.bird);
		this.topContainer.mask = this.topMask;
		this.topContainer.alpha = 0;
		//1920x1200
	
		this.face01.x = 335;
		this.face01.y = 157;
	
		this.face02.x = 335;
		this.face02.y = 157;
	
		this.bird.x = 1344-10;
		this.bird.y = 311-40;
	
	
		//選択エリア（Button）
		//乗算を綺麗に使いたいのでDOMでの合成ではなく、canvas内で処理する
		
		//Buttonの作成
		for (let i = 0; i < 5; i++) {
			var findUl = document.getElementById("top_main_col"+(i+1));
			var link = findUl.getElementsByTagName('a');
			var txt = findUl.getElementsByTagName('span');
			console.log(link[0].href,link[0].target,txt[0].textContent,txt[1].textContent);
			
			this.buttons[i] = new Button(i,
				txt[0].textContent,
				txt[1].textContent,
				link[0].href,
				link[0].target,
				(i===0)?false:true);
			
		}


		var textStyle = {
			fontSize:this.baseW*0.02,
			letterSpacing:1,
			fontFamily:['Crimson Text','serif'],
			fill:'white',
			wordWrap:true,
		};
		this.traceText = new PIXI.Text('0:0', textStyle);
		this.traceText.x = 10;
		this.traceText.y = 10;
		//this.stage.addChild(this.traceText);
		//this.stage.addChild(this.topMask);


		this.tweenbox = new PIXI.Graphics();
		this.tweenbox.beginFill(0x794fb1);
		this.tweenbox.drawRect(0,0,30,30);
		this.tweenbox.endFill();
		//this.stage.addChild(this.tweenbox);


		this.logo = new Logo();
		this.names = new Names();

		TweenMax.to(this.tweenbox, 1, {
			x: 500,  pixi:{fillColor: 0x0088f7}
		 });


		this.bird.y = 311-40;
		TweenMax.to(this.bird, 0.5, {y:311-20,repeat: -1,yoyo: true,ease:  Sine.easeInOut});

		var tm:TimelineMax = TimelinePlus.parallel(
			TimelinePlus.serial(
				TweenMax.to(this.backgradation, 4, {pixi:{tint: 0x368d86}}).delay(6),
				TweenMax.to(this.backgradation, 4, {pixi:{tint: 0x891406}}).delay(6),
				TweenMax.to(this.backgradation, 4, {pixi:{tint: 0x368db1}}).delay(6),
			),
			TimelinePlus.serial(
				TweenMax.to(this.backGround, 4, {pixi:{fillColor: 0xe8c745}}).delay(6),
				TweenMax.to(this.backGround, 4, {pixi:{fillColor: 0xAB2110}}).delay(6),
				TweenMax.to(this.backGround, 4, {pixi:{fillColor: 0x794fb1}}).delay(6),
			),
		);
		tm.repeat(-1);

		window.addEventListener("resize", this.handleResize.bind(this));
		window.addEventListener("orientationchange", this.handleOrientation.bind(this));
		this.handleResize(null);
		
		//スキップ
		if(this.active) {
			for (let i = 0; i < 5; i++) {
				this.buttons[i].start();
				var data = this.renderer.plugins.interaction.mouse.global;
				this.buttons[i].active(data);
			}
			this.firstCounter = 9999;
			TweenMax.to(this.topContainer, 1, {alpha: 1});
			this.names.skip();
			this.logo.skip();
		}

		this.update();
	}
	

	orientation;
	
	handleOrientation(event){
		var w = document.documentElement.clientWidth;
		var h = window.innerHeight;
		//var h:number= document.documentElement.clientHeight;
	}

	footerH:number = 0;

	// リサイズ処理
	handleResize(event) {
		var w:number= document.documentElement.clientWidth;
		var h:number= window.innerHeight;
		//var h:number= document.documentElement.clientHeight;

		var scale = window.devicePixelRatio;

		if(this.orientation != window.orientation){
			this.orientation = window.orientation;
			console.log('回転を感知',window.orientation,this.orientation,w,h)
			this.baseW = w;
			this.baseH = h;
		}

		// 画面幅・高さ、回転を取得
		var orientationStr:string;
		//スマホ・タブレットの場合記憶していた値を使う
		if(window.orientation == 0 || window.orientation == 180) {
			orientationStr = '縦向き';
		} else {
			orientationStr = '横向き';
		}

		if(this.device !== 'pc') {
			//スマホ・タブレットの場合記憶していた値を使う
			w = this.baseW;
			h = this.baseH;
		}

		

		//var scale = w/1920;
		//1920:w = 1200:nh
		//topContainer.scale = scale;
		// $('.wrapper') は表示要素を囲う箱を表します。
		var wrapper_width;
		var wrapper_height;
	
		// content_width, content_heightは、表示する要素のオリジナルの幅と高さを表します。
		// target_width, target_heightは実際に表示されるときの幅と高さが代入されます。
		var target_width;
		var target_height;
	
		// target_offset_topとtarget_offset_leftは表示される要素をセンタリングさせるためのオフセット値が代入されます。
		var target_offset_top;
		var target_offset_left;



		//if(w > 768 && this.device !== 'sp') {
		if(w > h || (this.device === 'pc' && w > 768)) {
			h = (h<1000)?h:1000;
			document.getElementById("topCanvas").style.maxHeight = '1000px'
			//横
			var fontBase = 100;
			this.renderer.resize(w, h);

			this.names.scale.y = this.names.scale.x = w*0.5/2800;
			this.names.x = w/2;
			this.names.y = h/4;
			this.logo.resize(w,h,false,this.device);
			if(this.firstCounter>60*10) {
				this.names.resize(h);
			}

		} else {
			if(this.device === 'pc') {
				h = (h>720)?h:720;
			}
				//縦
			this.renderer.resize(w, h);
			document.getElementById("topCanvas").style.maxHeight = '100%'

			this.names.scale.y = this.names.scale.x = w*0.8/2800;
			this.names.calculateBounds();
			this.names.x = w/2;
			this.names.y = h/4;

			this.logo.resize(w,h,true,this.device);
			if(this.firstCounter<60*10) {
			} else {
				this.names.resize(h);
			}

		}
		this.topMask.width = w;
		this.topMask.height = h;

		wrapper_width = w;
		wrapper_height = h;

		// Canvas要素の大きさを画面幅・高さに合わせる
		//画面サイズに合わせて、画像その他を調整する
		//coverを計算で実装する
		
		
		if(wrapper_height / wrapper_width > Const.CONTENT_HEIGHT / Const.CONTENT_WIDTH){
				// 囲う箱のほうが、表示する要素よりも縦長だった場合
				target_height = wrapper_height;
				target_width = wrapper_height * (Const.CONTENT_WIDTH / Const.CONTENT_HEIGHT);
				target_offset_top = 0;
				target_offset_left = (wrapper_width - target_width) / 2;
				
		}
		else{
			
				// 表示する要素のほうが、囲う箱よりも縦長だった場合
				target_width = wrapper_width;
				target_height = wrapper_width * (Const.CONTENT_HEIGHT / Const.CONTENT_WIDTH);
				target_offset_top = (wrapper_height - target_height) / 2;
				target_offset_left = 0;
		}
		

		this.topContainer.x = target_offset_left;
		this.topContainer.y = target_offset_top;
		this.topContainer.width = target_width;
		this.topContainer.height = target_height;
		console.log(this.topContainer.scale);


		//顔の比率を独自に調整
		//1239:1014

		let rate;
		let rateY;
		if(w > h || (this.device === 'pc' && w > 768)) {
			rate = 0.9;
			rateY = 0.1;
		} else {
			rate = 0.7;
			rateY = 0.15;

		}

		target_height = wrapper_height*rate;
		target_width = target_height * (1239 / 1014);
		target_offset_top = wrapper_height*rateY;
		target_offset_left = (wrapper_width - target_width) / 2;

		
		this.face01.height = target_height;
		this.face01.width = target_width;
		this.face01.y = target_offset_top;
		this.face01.x = target_offset_left;

		this.face02.height = target_height;
		this.face02.width = target_width;
		this.face02.y = target_offset_top;
		this.face02.x = target_offset_left;
		



		//if(w > 768 && this.device !== 'sp') {
		if(w > h || (this.device === 'pc' && w > 768)) {
			for (let i = 0; i < 5; i++) {
				this.buttons[i].resize(i * w/5,0,w/5,h,false,this.device);
			}

		} else {
			for (let i = 0; i < 5; i++) {
				this.buttons[i].resize(0,i * h/5,w,h/5,true,this.device);
			}
		}



		this.render();
	}




	firstCounter:number = 0;
	faceCounter:number = 0;
	update(){
		requestAnimationFrame(this.update); // 次の描画タイミングでanimateを呼び出す
		//背景の色変化
		//顔のアニメーション（切り替え）

		var flashTime = 3;
		var flash = 240;
		if(this.firstCounter<60*11) {
			this.firstCounter++;
			flashTime = 2;
			//最初のアニメーション
			//if(this.animeType === '5'){
				flash = 130;
				if(this.firstCounter == 10){
					TweenMax.to(this.topContainer, 1, {alpha: 1});
				} else if(this.firstCounter == 70) {
					this.names.start(this.animeType);
				} else if(this.firstCounter == flashTime*1+flash) {
					//Buttonのフラッシュ
					this.buttons[0].flash();
				} else if(this.firstCounter == flashTime*2+flash) {
					this.buttons[1].flash();
				} else if(this.firstCounter == flashTime*3+flash) {
					this.buttons[2].flash();
				} else if(this.firstCounter == flashTime*4+flash) {
					this.buttons[3].flash();
				} else if(this.firstCounter == flashTime*5+flash) {
					this.buttons[4].flash();

				} else if(this.firstCounter == 60*3) {
					for (let i = 0; i < 5; i++) {
						this.buttons[i].start(i);
					}
				} else if(this.firstCounter == 60*4) {
					console.log(this.firstCounter)
					for (let i = 0; i < 5; i++) {
						var data = this.renderer.plugins.interaction.mouse.global;
						this.buttons[i].active(data);
					}
					//console.log('cursor？')
					//document.getElementById("topCanvas").style.cursor = 'pointer';
				} else if(this.firstCounter == 60*6) {
					this.names.logoin();
					this.logo.logoin();
					this.firstCounter = 9999;
				}


		} else {
			this.faceCounter++;
			if(this.faceCounter === 60) {
				TweenMax.to(this.face01, 4, {alpha: 0});
				TweenMax.to(this.face02, 4, {alpha: 1});
			} else if(this.faceCounter === 60*6) {
				TweenMax.to(this.face01, 0, {alpha: 1});
				TweenMax.to(this.face02, 0, {alpha: 0});
			} else if(this.faceCounter === 60*7) {
				this.faceCounter = 0;
			}
		}


		this.render();
	}

	render(){
		this.renderer.render(this.stage);
	}

}




window.addEventListener("load",init);

function init(e){
	WebFont.load(
		{
			custom:
			{
				families: ['Oswald', 'Crimson Text']
			},
			loading: function()
			{
				//console.log('全てのWebフォントのロードが開始されたとき');
			},
			active: function()
			{
				//console.log('全てのWebフォントのロードが完了したとき');
				top();
			},
			inactive: function()
			{
				//console.log('全てのWebフォントのロードが失敗したとき');
				top();
			}
		}
	);
}

function top(){
	new Main();
}

